import axiosIns from '@/plugins/axios'

export default {
  // SDPプリンタの死活状態(最終ポーリング時刻とstale判定)。
  // レイアウト共通の警告バナーが定期取得する軽量API
  getHealth() {
    return axiosIns.get('/waiter/sdp_printer_health')
  },
}
